import type { ReactNode } from "react";
import { cn } from "@/utils/ui";

/** Every page opens the same way: display-face title, one line of description, actions on the right. */
export function PageHeader({
	title,
	description,
	actions,
	className,
}: {
	title: string;
	description?: React.ReactNode;
	actions?: ReactNode;
	className?: string;
}) {
	return (
		<header className={cn("flex flex-wrap items-end justify-between gap-x-6 gap-y-3", className)}>
			<div className="min-w-0">
				<h1 className="font-display text-2xl font-semibold tracking-tight text-foreground text-balance sm:text-3xl">{title}</h1>
				{description && <p className="mt-1 max-w-prose text-sm text-muted-foreground">{description}</p>}
			</div>
			{actions && <div className="flex items-center gap-2">{actions}</div>}
		</header>
	);
}
